import axios from "axios"

export const axiosInstance = axios.create({
    // baseURL: 'https://ztpl.net/precisioncontractdriving/backend/public/api/'
    // baseURL: 'https://apidemo.precisiondriving.uk/public/api/'
    baseURL: 'https://api.precisiondriving.uk/public/api/'

    // local
    // baseURL: 'http://192.168.0.113:8000/api'
})

const config = {

    // Local
    // appUrl: "/instructor/",
    // imageUrl: "http://192.168.0.113:8000/public/images/",


    // appUrl: "/precisioncontractdriving/instructor/",
    // imageUrl: "https://ztpl.net/precisioncontractdriving/backend/public/images/",

    appUrl: "/instructor/",
    // imageUrl: "https://apidemo.precisiondriving.uk/public/images/",

    imageUrl: "https://api.precisiondriving.uk/public/images/",
}

export const checkLoginStatus = (credential) => {
    try {
        if (!('id' in credential) && !('name' in credential) && !('email' in credential)) {
            return true;
        } else {
            return false
        }
    } catch (error) {
        return true
    }
}

export default config